export default {
  name: 'COOKIE_CONSENT',
  value: 'y',
  options: {
    path: '/',
    maxAge: 24 * 60 * 60 * 365, // year
    secure: true,
    httpOnly: false,
  },
};
